import React from "react";
import cx from "classnames";
export const EditorToolbar = ({ className, preventFocusOnClick, mode = "floating", onMouseDown, ...rest }) => {
    const handleMouseDown = (e) => {
        if (preventFocusOnClick) {
            e.preventDefault();
            onMouseDown === null || onMouseDown === void 0 ? void 0 : onMouseDown(e);
        }
    };
    return (React.createElement("div", { className: cx("editor-toolbar", `editor-toolbar--mode-${mode}`, className), role: "toolbar", onMouseDown: handleMouseDown, ...rest }));
};
